import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require("dojo/text!./teams_team_finder.html");

import FinderBaseV2 from '../../../FinderBase/FinderBaseV2';

class teams_team_finder extends compose(FinderBaseV2) {
    //templateString = template;

    private teamType2Icon: Record<string,string> = {
        "private":"far fa-eye-slash",
        "public":"far fa-eye",
        "hiddenMembership":"fas fa-low-vision",
        "unknownFutureValue":"fas fa-question",
        "unknown":"fas fa-bug"
    };
    private teamType2Translation: Record<string,string> = {
        "private": "MsTeamsIntegration_AdminPanel_Teams_VisibilityType_Private",
        "public": "MsTeamsIntegration_AdminPanel_Teams_VisibilityType_Public",
        "hiddenMembership": "MsTeamsIntegration_AdminPanel_Teams_VisibilityType_PrivateHiddenMembers",
        "unknownFutureValue": "General_Label_Undefined"
    };

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_MS_Teams_Integration_AdminPanel__NewChannel_TeamFinder_GetConfig",
            "Webtool_API_MS_Teams_Integration_AdminPanel__NewChannel_TeamFinder_GetData",
            lang.hitch(this, this._onClick_TableRow) as any,
            lang.hitch(this, this._tableFormatter) as any,
            /* {
                neededUserRole: null,
                callback: lang.hitch(this, this._onClick_CreateNew) as any
            }*/
        );
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onClick_TableRow(row: StaticTable.StaticTableRow<any>){
        let teamId = row.rowGroup.entity["ID"];
        let teamDisplayName = row.rowGroup.entity["teamDisplayName"];
        this.emit("selectedTeamID", {ID:teamId, displayName:teamDisplayName});
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<any>):boolean{
        switch (cell.name.toLowerCase()){
            case 'teamDisplayName'.toLowerCase():
                let dn = cell.displayValue as string;

                let dnElem = document.createElement('span');
                dnElem.classList.add("bold");
                dnElem.innerHTML = dn;
                dnElem.title = dn;

                cell.contentnode.innerHTML = "";
                cell.contentnode.appendChild(dnElem);
                return true;
                break;
            case 'teamDescription'.toLowerCase():
                let desc = cell.displayValue as string;

                let descElem = document.createElement('span');
                descElem.classList.add("italic");
                descElem.innerHTML = desc;
                descElem.title = desc;

                cell.contentnode.innerHTML = "";
                cell.contentnode.appendChild(descElem);
                return true;
                break;
            case 'teamMembershipType'.toLowerCase():
                let val = cell.displayValue as string;
                let labelTxt = this.translate(this.teamType2Translation[val]);
                cell.contentnode.innerHTML = "";
                let cellContainer = document.createElement('div');
                cellContainer.title = labelTxt
                cell.contentnode.appendChild(cellContainer);

                let ico = document.createElement("i");
                ico.setAttribute("class", this.teamType2Icon[val]);
                ico.classList.add("w3-padding-right");

                cellContainer.appendChild(ico);

                let labelSpan = document.createElement('span');
                labelSpan.innerHTML = labelTxt;
                labelSpan.classList.add("italic");

                cellContainer.appendChild(labelSpan);

                return true;
                break;
            default:
                console.warn("not implemented", cell.name, cell.entity);
                break;
        }
        return false;
    }

    private _onClick_CreateNew(ev:Event){
        // soll der user selber des team erstellen, wo senn ma denn? es leben is koa wunschkonzert
        throw "Not implemented";
    }

}

export default mdsWidget(teams_team_finder);
